export const template_0006 = `
<div class="all-floors-scroll-wrapper no-scrollbar" style="width:100%;overflow-x:auto;box-sizing:border-box; display: flex; justify-content: center">
    <style>
        .no-scrollbar {
            overflow: auto;
            scrollbar-width: none;
            /* Firefox */
            -ms-overflow-style: none;
            /* IE 10+ */
        }

        /* Ẩn scrollbar trên Chrome, Safari */
        .no-scrollbar::-webkit-scrollbar {
            display: none;
            width: 0px;
            height: 0px;
        }
    </style>
    <div class="all-floors-inner floor-guide-drag-container"
        style="display:flex;box-sizing:border-box;">
        <div class="floor-guide-floors" id="building">
            <div class="floor-guide-mall-name">
                <div class="floor-guide-mall-name-tts">아쿠아몰</div>
            </div>
            <div class="floor-guide-floor" data-id="FL-skjz9gcftizm0480" data-x="1444" data-y="1910">
                <span class="floor-guide-floor-name english">4F</span>
                <span class="floor-guide-floor-desc">F&amp;BㅣGDR골프아카데미ㅣ골프존마켓ㅣ헤어샵ㅣ헤드스파샵</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-tnzijhdjtnqd0499" data-x="1444" data-y="1910">
                <span class="floor-guide-floor-name english">3F</span>
                <span class="floor-guide-floor-desc">SPAㅣ패션잡화ㅣ올리브영ㅣ한샘디자인파크</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-s4msk8pdatly0520" data-x="1444" data-y="1910">
                <span class="floor-guide-floor-name english">2F</span>
                <span class="floor-guide-floor-desc">유니클로ㅣ삼성모바일ㅣ롯데마트</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-1hrbek9p9ntq10341" data-x="1444" data-y="1910">
                <span class="floor-guide-floor-name english">1F</span>
                <span class="floor-guide-floor-desc">영패션ㅣ애플샵ㅣ잡화ㅣ롯데마트</span>
            </div>
        </div>
    </div>
</div>`;
